import axiosInstance from "./axios";

export class HorarioService {
    getHorarios() {
        return axiosInstance
            .get(`/horario`)
            .then((res) => res.data)
    }

    addHorario(dto) {
        return axiosInstance
            .post(`/horario`, dto)
            .then((res) => res.data)
    }

    updateHorario(dto) {
        return axiosInstance
            .put(`/horario/${dto._id}`, dto)
            .then((res) => res.data)
    }

    deleteHorario(id) {
        return axiosInstance
            .delete(`/horario/${id}`)
            .then((res) => res.data)
    }
}
